import { observerEpicHelper } from 'epics/helpers'
import { Constants as AlgoliaActions, Actions as AlgoliaEventActions } from 'actions/algolia'
import {
  selectedFacetsToAlgoliaQueryString,
  selectedFacetsToAlgoliaEventFilter,
} from 'lib/algolia/v2'
import { Actions as AlgoliaDataActions } from 'actions/algolia2/data'
import { algoliaArtworksApi, algoliaEventsApi } from 'apis/algolia'
import { getMeasurementUnit, getUserID } from 'selectors/user/session'
import { Actions as ScrollActions } from 'actions/utility/scroll'
import { Actions as PageActions } from 'actions/page'
import { getAlgoliaUserToken, getUserPreferencesDestinationZone } from 'selectors/user/cookie'
import { setAlgoliaQueryIDInLocalStorage } from 'lib/algolia/v2/helpers'
import { applicationId, searchApi } from '../helpers/constants'
import { Actions as AppActions, Constants } from '../actions'
import { getUrlStringWithParams } from '../selectors/url'
import { getHitsPerPage, getPaginationCurrent, getSortIndice } from '../selectors/algolia'
import { getArtistId } from '../selectors/app'
import { getSelectedFacets } from '../selectors/facets'

export const updateHitsPerPageEpic = observerEpicHelper(
  [Constants.UPDATE_HITS_PER_PAGE],
  async ({ action, observer, store }) => {
    const url = getUrlStringWithParams({
      hitsPerPage: action.payload,
      page: '',
    })({ ...store.value })
    observer.next(AppActions.UPDATE_URL(url))
    observer.next(ScrollActions.SCROLL_TO_TOP({}))
    observer.complete()
  }
)
export const updatePageEpic = observerEpicHelper(
  [Constants.UPDATE_PAGE],
  async ({ action, observer, store }) => {
    const url = getUrlStringWithParams({
      page: action.payload,
    })({ ...store.value })
    observer.next(AppActions.UPDATE_URL(url))
    observer.next(ScrollActions.SCROLL_TO_TOP({}))
    observer.complete()
  }
)
export const updateAlgoliaEpic = observerEpicHelper(
  [Constants.UPDATE_ALGOLIA],
  async ({ action, observer, store }) => {
    observer.next(PageActions.IS_READY(false))
    // Get Algolia Config Data: applicationId, searchApi, searchIndice
    // Update Sort
    const searchIndice = getSortIndice({ ...store.value })
    const hitsPerPage = getHitsPerPage({ ...store.value })
    const pageNumber = getPaginationCurrent({ ...store.value })
    const selectedFacets = getSelectedFacets({ ...store.value })
    const userId = getArtistId({ ...store.value })
    const destinationZone = getUserPreferencesDestinationZone({ ...store.value })
    const filters = selectedFacetsToAlgoliaQueryString(
      { ...selectedFacets }, // selected facets
      {
        measurementUnit: getMeasurementUnit({ ...store.value }),
        destinationZone,
      } // Additional params
    )
    const algoliaParams = {
      applicationId,
      searchApi,
      searchIndice,
      filters,
      hitsPerPage,
      page: pageNumber,
      query: `"${userId}"`,
      restrictSearchableAttributes: 'id_user',
      typoTolerance: false,
      // Accept override params => `page`, hitsPerPage``
      ...(action.payload ? action.payload : {}),
      destinationZone,
    }
    const algoliaResults = await algoliaArtworksApi(algoliaParams)
    observer.next(AlgoliaDataActions.SET_DATA({ ...algoliaResults }))
    // store ALGOLIA_QUERY_ID in local storage
    const { queryID } = algoliaResults
    const userID = getUserID({ ...store.value })
    const eventFilters = selectedFacetsToAlgoliaEventFilter(selectedFacets)
    setAlgoliaQueryIDInLocalStorage(queryID)
    observer.next(
      AlgoliaEventActions.EVENT({
        eventName: 'select_filter',
        eventType: 'click',
        authenticatedUserToken: String(userID) || '',
        ...(eventFilters ? { filters: [eventFilters] } : { filters: ['none: none'] }),
        ...(queryID && {
          queryID: queryID,
        }), // pass queryID only if its present, otherwise do not pass
      })
    )
    observer.next(PageActions.IS_READY(true))
    observer.complete()
  }
)
export const algoliaEventEpic = observerEpicHelper(
  [AlgoliaActions.EVENT],
  async ({ action, observer, store }): Promise<void> => {
    const state = { ...store.value }
    const userToken = getAlgoliaUserToken(state)
    const searchIndice = getSortIndice(state)
    algoliaEventsApi({
      events: [
        {
          index: searchIndice,
          userToken,
          ...action.payload,
        },
      ],
    })
    observer.complete()
  }
)
export default [algoliaEventEpic, updateAlgoliaEpic, updateHitsPerPageEpic, updatePageEpic]
